import { render, staticRenderFns } from "./VModalManagerItem.vue?vue&type=template&id=4bf8941c&scoped=true&"
import script from "./VModalManagerItem.vue?vue&type=script&lang=ts&"
export * from "./VModalManagerItem.vue?vue&type=script&lang=ts&"
import style0 from "./VModalManagerItem.vue?vue&type=style&index=0&id=4bf8941c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8941c",
  null
  
)

export default component.exports